/* Pukkart · comportamiento minimo del tema */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-menu]');
  if (b) { document.querySelector('.nav nav').classList.toggle('open'); }

  var s = e.target.closest('[data-sonido]');
  if (s) {
    var v = s.parentNode.querySelector('video');
    if (v) { v.muted = !v.muted; if (!v.muted) v.play(); s.textContent = s.dataset[v.muted ? 'on' : 'off']; }
  }

  var t = e.target.closest('[data-tab]');
  if (t) {
    var grupo = t.closest('[data-tabs]');
    grupo.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.toggle('on', x === t); });
    grupo.parentNode.querySelectorAll('[data-panel]').forEach(function (p) {
      p.hidden = p.dataset.panel !== t.dataset.tab;
    });
  }

  var g = e.target.closest('[data-galeria]');
  if (g) {
    var caja = document.getElementById('pdp-main');
    caja.innerHTML = g.dataset.medio === 'video'
      ? '<video src="' + g.dataset.src + '" controls autoplay muted loop playsinline></video>'
      : '<img src="' + g.dataset.src + '" alt="">';
    g.closest('.thumbs').querySelectorAll('[data-galeria]').forEach(function (x) { x.classList.toggle('on', x === g); });
  }
});
